<template>
  <v-card tile v-if="vehicle !== null">
    <v-card-title>
      <v-row>
        <v-col cols="12">
          <span>Aktivnost vozila {{ vehicle.registration_plate }}</span>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="vehicleActivity.data"
        :page.sync="vehicleActivity.current_page"
        :items-per-page="vehicleActivity.per_page"
        :server-items-length="vehicleActivity.total"
        :options.sync="tableOptions"
        @update:options="loadVehicleActivity"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50],
        }"
        sort-by="id"
        class="elevation-1"
        @click:row="openEmployee"
      >
        <template v-slot:[`item.employee_id`]="{ item }">
          {{
            item.employee
              ? item.employee.first_name + " " + item.employee.last_name
              : ""
          }}
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          {{ $moment(item.created_at).format("DD.MM.YYYY HH:mm") }}
        </template>
        <template v-slot:[`item.user_id`]="{ item }">
          {{ item.user ? item.user.name : "" }}
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="loadVehicleActivity">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
  export default {
    data: () => ({
      vehicle: null,
      vehicleActivity: {
        data: [],
      },
      headers: [
        { text: "Voznik", value: "employee_id" },
        { text: "Datum", value: "created_at" },
        { text: "Administrator", value: "user_id" },
      ],

      tableOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["created_at"],
        sortDesc: [true],
      },
    }),
    mounted() {
      this.loadVehicle();
      this.loadVehicleActivity();
    },
    methods: {
      loadVehicle() {
        this.$http
          .get("api/v1/vehicles/" + this.$route.params.vehicleId)
          .then((response) => {
            this.vehicle = response.data;
          })
          .catch(() => {
            this.$router.push({ name: "Vehicles" });
          });
      },
      loadVehicleActivity() {
        let orderBy = {};
        if (
          this.tableOptions.sortBy.length > 0 &&
          this.tableOptions.sortDesc.length > 0
        ) {
          orderBy[this.tableOptions.sortBy[0]] =
            this.tableOptions.sortDesc[0] === true ? "desc" : "asc";
        }
        let params = {
          page: this.tableOptions.page,
          perPage: this.tableOptions.itemsPerPage,
          orderBy,
          filters: { vehicle_id: this.$route.params.vehicleId },
        };
        this.$http
          .get("api/v1/vehicle-activity", { params })
          .then((response) => {
            this.vehicleActivity = response.data;
          });
      },
      openEmployee(item) {
        if (item.employee_id === null) {
          return;
        }
        this.$router.push({
          name: "Employee",
          params: { id: item.employee_id },
        });
      },
    },
  };
</script>
<style></style>
